import { Button, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import Radiogroup from './../../../src/adf/adf-screener/radiogroup'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import STATIC_TEXT from '../../content/common.json'
import { getUserEntitiesNJourneys, triggerInvite } from '../../services/bff-service'
import { setSnackBar } from '../../stores/ui/ui-action'
import { setUserAction } from '../../stores/user/user-action'
import CONSTANTS from '../../utils/constants'
import CustomLoading from '../custom/custom-loading'
import FormInput from '../portico/input/form-input'
// import Radiogroup from '../portico/radiogroup/radiogroup'
import Spacing from '../portico/spacing/spacing'
import PublicWrapper from '../public-wrapper-v2/public-wrapper'
import useInUsaStyles from './in-usa.styles'
import usePoll from '../../shared/hooks/use-polling'
import { PortalLoading } from '../portal-loading'
import { hasInProgressJourney } from '../../utils/fenergo-utils'

export const InUsa = () => {
    const user = useSelector((state: any) => state.user)
    const dispatch = useDispatch()
    const classes = useInUsaStyles()
    const [isDisabled, setDisabled] = useState(true)
    const [companyName, setCompanyName] = useState(user.companyName)
    const [submitting, setSubmitting] = useState<boolean>(false)
    const [newCompanySubmitting, setNewCompanySubmitting] = useState<boolean>(false)
    const [radioValue, setRadioChange] = useState(() => {
        if (user.countryOfIncorporation === 'US') {
            return 'Yes'
        } else if (user.countryOfIncorporation === 'notUSA') {
            return 'No'
        } else {
            return ''
        }
    })
    const navigate = useNavigate()
    const location = useLocation()

    const isNextCompany = determineisNextCompany(location)

    const { result, start: startPoll, stop: stopPoll } = usePoll(getUserEntitiesNJourneys, 5000)

    useEffect(() => {
        if (hasInProgressJourney(result?.companies)) {
            stopPoll()
            setNewCompanySubmitting(false)
            navigate('/')
            navigate(0) // reloads the page
        }
    }, [result])

    const handleRadioChange = event => {
        setRadioChange(event.target.value)
    }

    // Note: causes a 'not mounted' warning while testing, but these warnings now get
    // ignored in React 18+
    const handleInputChange = event => {
        setCompanyName(event.target.value)
    }

    const handleSubmit = async () => {
        if (radioValue === 'Yes' && isNextCompany) {
            const updatedUser = {...user, companyName, countryOfIncorporation: 'US', isNextCompany }
            setNewCompanySubmitting(true)
            await triggerInvite(updatedUser)

            setTimeout(() => {
                stopPoll()
                setNewCompanySubmitting(false)
                dispatch( setSnackBar({ show: true, message: 'We encountered an issue. Please try again.', messageType: 'error' }) )
            }, 90_000)

            startPoll()
            
            return
        }
        
        if (radioValue === 'Yes') {
            setSubmitting(true)
            const updatedUser = {...user, companyName, countryOfIncorporation: 'US', isNextCompany }
            dispatch(setUserAction(updatedUser))

            try {
                await triggerInvite(updatedUser)
                setSubmitting(false)
                navigate('/verifyemail')
            } catch(err) {
                setSubmitting(false)
                dispatch(setSnackBar({ show: true, message: 'We apologize, the request failed. Please submit again.', messageType: 'error' }))
            }
        } else if (radioValue === 'No') {
            dispatch(setUserAction({ ...user, companyName, countryOfIncorporation: 'notUSA' }))
            navigate('/in-usa/error')
        }
    }

    useEffect(() => {
        if (!user.email) {
            navigate('/welcome')
        }
    })

    useEffect(() => {
        if (companyName !== '' && radioValue) {
            setDisabled(false)
        } else {
            setDisabled(true)
        }
    }, [companyName, radioValue])

    return (
        <div className={classes.trapezoidBgInUsa}> 
            <>
                {submitting && <CustomLoading message='Loading...' />}
                {newCompanySubmitting && <PortalLoading message='Starting New Application (this may take a minute) ...' />}
                <PublicWrapper
                    data-testid='publicWrapper'
                    title={STATIC_TEXT.inUsa.title}
                    displayPrivacyPolicyFooter={true}
                    backgroundClass={classes.root}
                    contentWrapperClass={classes.inUsaWrapper}
                >
                    <>
                        <Typography variant='h2' style={{ width: '611px', fontWeight: '700', fontSize: '30px', color: '#212121', paddingTop: '40px' }} className={classes.title}>
                            {STATIC_TEXT.inUsa.heading}
                        </Typography>
                        <Spacing></Spacing>
                        <Spacing></Spacing>
                        <Spacing variable='spacing-base' />
                        <Typography variant='body1' style={{ width: '611px', fontWeight: '500', fontSize: '20px', color: '#212121', marginBottom: '24px' }} className={classes.mobileWidth}>{STATIC_TEXT.inUsa.inputLabel}</Typography>
                        <FormInput className={classes.inputBox}
                            name='companyName'
                            label='Doing business as/trade name'
                            onChange={handleInputChange}
                            value={companyName}
                            setValue={setCompanyName}
                        />
                        <Spacing variable='spacing-base' />
                        <Spacing variable='spacing-base' />
                        <Spacing variable='spacing-base' />
                        <Spacing variable='spacing-base' />
                        <Spacing variable='spacing-base' />
                        <Typography variant='body1' style={{ width: '611px', fontWeight: '500', fontSize: '20px', color: '#212121' }} className={classes.mobileWidth}>{STATIC_TEXT.inUsa.radioLabel}</Typography>
                        <Spacing variable='spacing-base' />
                        <Spacing variable='spacing-base' />
                        <div className={classes.radio}>
                            <Radiogroup
                                uiRenderOptions={{ row: false }}
                                label='businessInUsa'
                                name='businessInUsa'
                                items={[{ label: CONSTANTS.YES, value: CONSTANTS.YES }, { label: CONSTANTS.NO, value: CONSTANTS.NO }]}
                                onChange={handleRadioChange}
                                value={radioValue}
                            />
                        </div>
                        <Spacing variable='spacing-base' />
                        <Spacing variable='spacing-base' />
                        <Spacing variable='spacing-base' />
                        <Spacing variable='spacing-base' />
                        <Button
                            className={classes.continueBtn}
                            disabled={isDisabled}
                            onClick={handleSubmit}
                        >
                            {STATIC_TEXT.inUsa.continueButton}
                        </Button>
                    </>
                </PublicWrapper >
            </>
        </div>    
    )
}

// Helpers

function determineisNextCompany(history) {
    const queryParams = new URLSearchParams(history.search)
    const isNextCompany = queryParams.get('is_next_company')? true : false
    return isNextCompany
}